
<router-outlet></router-outlet> 
 